import { useApp }  from '../../../app/AppContext.jsx'
import { useHero, HeroContextProvider } from '../context/HeroContext.jsx'

import { HERO_VIEW } from '../../../shared/constants/heroView.js'
import { SECTION_ID } from '../../../shared/constants/sectionIds.js'

import { CatalogMobileController } from '../../catalog/components/CatalogMobileController.jsx'
import { ModelView }         from './ModelView/ModelView.jsx'
import { VisualizationView } from './VisualizationView/VisualizationView.jsx'

import { BimCadaplusLogoTag } from '../../../shared/ui/BimCadaplusLogoTag/BimCadaplusLogoTag.jsx'

import styles from './HeroView.module.scss'

// ── Inner component (needs HeroContext) ───────────────────────────────────────

function HeroViewInner() {

  // ── Context reads ─────────────────────────────────────────────────────────
  const { appCapabilities, sectionRefs, isMobile } = useApp()
  const { heroCapabilities, activeView, changeViewHandler } = useHero()

  const { heroPaddingEnabled } = appCapabilities;

  // ── Render ────────────────────────────────────────────────────────────────

  if (!heroCapabilities.hasHeroSection) return null

  return (
    <section
      ref={sectionRefs.hero}
      className={styles.heroView}
      data-section={SECTION_ID.HERO}
      data-hero-padding={heroPaddingEnabled}
    >
      <div className={styles.canvas}>
        {activeView === HERO_VIEW.VISUALIZATION && (
          <VisualizationView />
        )}
        {(activeView === HERO_VIEW.SITE || activeView === HERO_VIEW.BUILDING) && (
          <ModelView onClose={() => changeViewHandler(HERO_VIEW.VISUALIZATION)} />
        )}
      {/* Logo tag — bottom-left corner of the image */}
      <BimCadaplusLogoTag 
        isMobile={isMobile}
        size="medium" 
        position={isMobile ? "left" : "bottom"}
        className={styles.logoOverlay} 
      />  
      </div>
      <CatalogMobileController />
    </section>
  )
}

// ── Public export (mounts provider) ──────────────────────────────────────────

/**
 * Top-level Hero view component.
 *
 * Mounts `HeroContextProvider` and renders the hero-section wrapper.
 * Guards on `heroCapabilities.hasHeroSection` — returns null when the section
 * is disabled by panel settings or no renderable assets exist.
 *
 * Must be mounted inside `AppContextProvider` (reads projectConfig, panelSettings).
 * Attaches to `sectionRefs.hero` from AppContext for scroll navigation.
 */
export function HeroView() {
  return (
    <HeroContextProvider>
      <HeroViewInner />
    </HeroContextProvider>
  )
}
